import 'regenerator-runtime/runtime';
import bookingsListSaga from 'modules/bookings/redux/sagas';
import paymentSagas from 'modules/payment/redux/sagas';
import dac7Sagas from 'modules/dac7/redux/sagas';
import reviewsSagas from 'modules/reviews/redux/sagas';
import tagsSagas from 'modules/tags/redux/sagas';
import flagsSagas from 'modules/flags/redux/sagas';

import bookingsSaga from './bookingsSaga';
import conversationSaga from './conversationSaga';
import conversationsSaga from './conversationsSaga';
import cottageSaga from './cottageSaga';
import cottagesSaga from './cottagesSaga';
import loginSagas from './loginSagas';
import notificationSagas from './notificationSagas';
import userSagas from './userSagas';
import watchSCAEnrollment from './scaEnrollmentSaga';
import watchSCAVerification from './scaVerificationSaga';
import watchSCAVerifyRecipientRedirect from './scaRecipientReturnSaga';
import scaResumeSaga from './scaResumeSaga';
import scaPollLocalSaga from './scaPollLocalSaga';

export default function* rootSaga() {
  yield []
    .concat(bookingsSaga)
    .concat(conversationSaga)
    .concat(conversationsSaga)
    .concat(cottageSaga)
    .concat(cottagesSaga)
    .concat(loginSagas)
    .concat(notificationSagas)
    .concat(userSagas)
    .concat(watchSCAEnrollment)
    .concat(watchSCAVerification)
    .concat(watchSCAVerifyRecipientRedirect)
    .concat(scaResumeSaga)
    .concat(scaPollLocalSaga)

    .concat(bookingsListSaga)
    .concat(paymentSagas)
    .concat(dac7Sagas)
    .concat(reviewsSagas)
    .concat(tagsSagas)
    .concat(flagsSagas);
}
